import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AddDevicesSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t(
        'common:pages.organization_overview.add_devices_to_org.success',
      )}
    />
  );
};

export default AddDevicesSuccess;
